class LoadingBar extends HTMLElement {
  constructor() {
    super();

    document.addEventListener(
      "theme:loading:start",
      this._onLoadingStart.bind(this)
    );
    document.addEventListener(
      "theme:loading:end",
      this._onLoadingEnd.bind(this)
    );

    this.addEventListener("transitionend", this._onTransitionEnd.bind(this));
  }

  _onLoadingStart() {
    this.classList.add("is-visible");
    this.style.width = "40%";
  }

  _onLoadingEnd() {
    this.style.width = "100%";
    this.classList.add("is-finished");
  }

  _onTransitionEnd(event) {
    if (
      event.propertyName === "width" &&
      this.classList.contains("is-finished")
    ) {
      this.classList.remove("is-visible");
      this.classList.remove("is-finished");
      this.style.width = "0";
    }
  }
}

customElements.define("loading-bar", LoadingBar);
